export const PACKAGE_LOCATION = 'jira-business.common.ui.new-lozenge';
